import Swiper from "swiper";
import {initHistorySlider} from "../../../default/global/js/history";

export function slides() {
    initHistoryReuschSlider();
    initQualitySwiper();
}

function initQualitySwiper() {
    let els = document.querySelectorAll(".qualitySwiper");
    for(let el of els) {
        let start = 0;
        const swiperVideoGallery = new Swiper(el, {
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    spaceBetween: 10,
                },
                768: {
                    spaceBetween: 20
                },
            },
        });
    }
}


function initHistoryReuschSlider() {
    let els = document.querySelectorAll(".historySwiper");
    for(let el of els) {
        const swiperVideoGallery = new Swiper(el, {
            loop: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1.3,
                    spaceBetween: 70,
                },
                1024: {
                    slidesPerView: 1.3,
                    spaceBetween: 150
                },
            },
        });
    }
}